/**
 * gets formatted numbers
 * @param value The value to format
 * @param minimumFractionDigits The minimum number of fraction digits to use and possible values are from 0 to 100.
 * @param maximumFractionDigits The maximum number of fraction digits to use and possible values are from 0 to 100.
 * @returns formatted numerical value.
 */

export function getFormattedValue(value: string | number, minimumFractionDigits?: number, maximumFractionDigits?: number): string {
  const defaultFractionDigit = 2;
  const parsedValue = typeof value === "string" ? parseFloat(value) : value;

  const minFractionDigits = minimumFractionDigits ?? defaultFractionDigit;
  const maxFractionDigits = maximumFractionDigits ?? defaultFractionDigit;

  if (isNaN(parsedValue)) {
    return value.toString();
  }

  const options = {
    style: "decimal",
    currency: "USD",
    notation: "standard",
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  } as Intl.NumberFormatOptions;

  /*
   page crashes with error avoid RangeError: maximumFractionDigits value is out of range.
   maximumFractionDigits value shouldn't be greater than minimumFractionDigits
   Below check is to eliminate the error.
  */
  if(minFractionDigits > maxFractionDigits) {
    delete options.maximumFractionDigits;
  }

  return new Intl.NumberFormat("us-US", options).format(parsedValue);
}
